// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2cy0d","options":"AnswerScale_options__2alE2","selected":"AnswerScale_selected__38Uty"};